import styled from 'vue3-styled-components';

// 메인 컨테이너
export const SystemContainer = styled.div`
    padding: 0 24px;
    margin-left: 260px;
    min-height: 100vh;
    background: #f8fafc;
    border-radius: 10px;
`;

export const MainContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 0;
`;

// 헤더 섹션
export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 8px 0;
    }
    
    span {
        color: #64748b;
        font-size: 16px;
        font-weight: 400;
    }
`;

// 카드 그리드
export const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
    gap: 24px;
`;

// 관리 카드
export const ManagementCard = styled.div`
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
    overflow: hidden;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        border-color: #0f4c5c;
    }
`;

export const CardHeader = styled.div`
    padding: 24px 24px 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f3f4;
`;

export const CardTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: #212529;
    margin: 0;
    flex: 1;
`;

export const CardActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const ActionButton = styled.button`
    background: ${props => props.size === 'small'
        ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
        : 'linear-gradient(135deg, #0d6efd 0%, #0f4cfc 100%)'};
    color: white;
    border: none;
    padding: ${props => props.size === 'small' ? '5px 10px' : '12px 24px'};
    border-radius: 8px;
    font-size: ${props => props.size === 'small' ? '14px' : '14px'};
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    }
`;

export const CardDescription = styled.p`
    font-size: 14px;
    color: #6c757d;
    margin: 0;
    padding: 16px 24px;
    line-height: 1.5;
    background: #f8f9fa;
`;

export const CardStats = styled.div`
    display: flex;
    gap: 24px;
    padding: 20px 24px;
    background: #ffffff;
    border-bottom: 1px solid #f1f3f4;
`;

export const StatItem = styled.div`
    text-align: center;
    flex: 1;
`;

export const StatNumber = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #0d6efd;
    margin-bottom: 4px;
`;

export const StatLabel = styled.div`
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
`;

// 검색 섹션
export const SearchSection = styled.div`
    padding: 20px 24px;
    background: #ffffff;
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.3s ease;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
    }

    &::placeholder {
        color: #adb5bd;
    }
`;

export const SearchButton = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    padding: 8px 10px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 3px;

    &:hover {
        transform: translateY(-2px);
    }
`;

// 테이블 컨테이너
export const TableContainer = styled.div`
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 24px 24px 24px 24px;
    border: 1px solid #e9ecef;
    width: calc(100% - 48px);
    overflow-x: auto;
    overflow-y: hidden;

    /* 스크롤바 스타일링 */
    &::-webkit-scrollbar {
        height: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
        
        &:hover {
            background: #a8a8a8;
        }
    }
`;

// 테이블 공통 스타일 (헤더와 바디 모두 적용)
export const TableCommon = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 50px 80px 130px 80px 60px;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
        border-bottom: none;
    }
`;

// 테이블 헤더
export const TableHeader = styled(TableCommon)`
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 2px solid #dee2e6;
    height: 50px;
`;

// 테이블 바디
export const TableBody = styled.div`
    width: 100%;
`;

// 테이블 행
export const TableRow = styled(TableCommon)`
    &:hover {
        background: #f8f9fa;
    }
`;

// 테이블 셀 공통 스타일 (헤더와 바디 모두 적용)
export const TableCellCommon = styled.div`
    font-size: 14px;
    text-align: center;
    border-right: 1px solid #e9ecef;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    &:last-child {
        border-right: none;
    }
`;

// 테이블 헤더 셀
export const TableHeaderCell = styled(TableCellCommon)`
    font-weight: 600;
    color: #495057;
    padding: 16px 12px;
`;

// 테이블 바디 셀
export const TableCell = styled(TableCellCommon)`
    color: #212529;
`;

// 담당자 정보 스타일
export const ManagerName = styled.div`
    font-weight: 600;
    color: #212529;
`;

// 테이블 액션 버튼
export const TableActions = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
`;

export const DeleteButton = styled.button`
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
    }
`;

export const CardContent = styled.div`
    padding: 20px 24px;
    background: #ffffff;
`;

export const RecentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const RecentItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;

    &:hover {
        background: #e9ecef;
        border-color: #0d6efd;
    }
`;

export const ItemAvatar = styled.div`
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #0d6efd 0%, #0f4cfc 100%);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
`;

export const ItemInfo = styled.div`
    flex: 1;
`;

export const ItemName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 2px;
`;

export const ItemRole = styled.div`
    font-size: 12px;
    color: #6c757d;
`;

export const ItemActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const EditButton = styled.button`
    background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
    }
`;

// export const CardFooter = styled.div`
//     padding: 16px 24px;
//     background: #f8f9fa;
//     border-top: 1px solid #e9ecef;
//     text-align: center;
// `;

// export const ViewAllButton = styled.button`
//     background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
//     color: white;
//     border: none;
//     padding: 10px 20px;
//     border-radius: 8px;
//     font-size: 13px;
//     font-weight: 600;
//     cursor: pointer;
//     transition: all 0.3s ease;

//     &:hover {
//         transform: translateY(-2px);
//         box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
//     }
// `;

// 반응형 디자인을 위한 미디어 쿼리 수정
const responsiveStyles = `
    @media (max-width: 1200px) {
        ${SystemContainer} {
            margin-left: 240px;
            padding: 24px;
        }
        
        ${CardsGrid} {
            grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
            gap: 20px;
        }

        ${TableContainer} {
            width: calc(100% - 48px);
        }
    }

    @media (max-width: 768px) {
        ${SystemContainer} {
            margin-left: 0;
            padding: 20px;
        }
        
        ${HeaderTitle} {
            font-size: 28px;
        }
        
        ${CardsGrid} {
            grid-template-columns: 1fr;
            gap: 20px;
        }
        
        ${ManagementCard} {
            margin-bottom: 20px;
        }

        ${TableContainer} {
            width: calc(100% - 48px);
            margin: 0 16px 16px 16px;
        }

        ${TableRow} {
            grid-template-columns: 1fr;
            gap: 8px;
            padding: 12px;
            height: auto;
            min-width: auto;
        }

        ${TableCell} {
            border-right: none;
            border-bottom: 1px solid #e9ecef;
            justify-content: flex-start;
            height: auto;
            min-height: 40px;
            width: auto;
            min-width: auto;
            max-width: none;
        }

        ${TableHeaderCell} {
            display: none;
        }
    }

    @media (max-width: 480px) {
        ${TableContainer} {
            width: calc(100% - 32px);
            margin: 0 12px 12px 12px;
        }
    }
`;

// 회사 정보 카드 스타일
export const CompanyInfoGrid = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px 24px;
`;

export const CompanyCardHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 20px;
`;

export const CompanyHeaderInfo = styled.div`
    flex: 1;
`;

export const CompanyName = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 6px;
    line-height: 1.3;
`;

export const InfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f8f9fa;

    &:last-child {
        border-bottom: none;
    }
`;

export const InfoLabel = styled.div`
    font-size: 14px;
    color: #6c757d;
    font-weight: 600;
    min-width: 100px;
`;

export const InfoValue = styled.div`
    font-size: 14px;
    color: #212529;
    font-weight: 500;
    text-align: right;
    flex: 1;
    margin-left: 20px;
    word-break: break-all;
`;

export const CompanyCardFooter = styled.div`
    border-top: 1px solid #f8f9fa;
    padding-top: 20px;
`;

export const DocumentStatusGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
`;

export const DocumentStatusItem = styled.div`
    position: relative;
    width: 150px;
    height: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    overflow: hidden; // 이미지가 컨테이너를 벗어나지 않도록
`;

export const DocumentIcon = styled.div`
    font-size: 24px;
    margin-bottom: 8px;
    opacity: ${props => props.hasDocument ? 1 : 0.4};
`;

export const DocumentLabel = styled.div`
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 6px;
    font-weight: 600;
    text-align: center;
`;

export const DocumentStatus = styled.div`
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 10px;
    font-weight: 600;
    background: ${props => props.hasDocument
        ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
        : 'linear-gradient(135deg, #6c757d 0%, #495057 100%)'};
    color: white;
    min-width: 50px;
    text-align: center;
`;

export const DocumentImage = styled.img`
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    margin-top: 8px;
`;

// 회사 이미지 컨테이너
export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
`;

// 회사 이미지 스타일
export const CompanyImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain; // 이미지가 컨테이너 안에 모두 보이도록 조정
    border-radius: 8px;
    max-width: 100%;
    max-height: 100%;
`;

// 이미지 삭제 버튼
export const DeleteImageButton = styled.button`
    position: absolute;
    top: 1px;
    right: 1px;
    width: 20px;
    height: 20px;
    background: rgba(255, 0, 0, 0.9);
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    transition: all 0.2s ease;
    z-index: 10;

    &:hover {
        background: rgba(255, 0, 0, 1);
        transform: scale(1.1);
    }
`;

// 이미지 등록 버튼 스타일 조정
export const ImageUploadButton = styled.button`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 12px;
    text-align: center;
    padding: 8px;

    &:hover {
        background: #e9ecef;
        border-color: #adb5bd;
        color: #495057;
    }
`;

// 반응형 디자인
const responsiveCompanyStyles = `
    @media (max-width: 768px) {
        ${CompanyInfoGrid} {
            grid-template-columns: 1fr;
            gap: 16px;
            padding: 16px 20px;
        }
        
        ${DocumentStatusGrid} {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
        }
    }
    
    @media (max-width: 480px) {
        ${CompanyCardHeader} {
            flex-direction: column;
            text-align: center;
            gap: 12px;
        }
        
        ${InfoRow} {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
        }
        
        ${InfoValue} {
            text-align: left;
            margin-left: 0;
        }
    }
`;

// 공유업체 관련 스타일 추가
export const PartnerName = styled.div`
    font-weight: 600;
    color: #212529;
`;

export const StatusBadge = styled.div`
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    min-width: 50px;
    
    background: ${props => {
        switch (props.status) {
            case 'active':
                return 'linear-gradient(135deg, #28a745 0%, #20c997 100%)';
            case 'pending':
                return 'linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)';
            case 'inactive':
                return 'linear-gradient(135deg, #6c757d 0%, #495057 100%)';
            default:
                return '#6c757d';
        }
    }};
    
    color: white;
`;

// 공유업체용 테이블 스타일 (3개 열)
export const PartnerTableCommon = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 100px 1fr 100px;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
        border-bottom: none;
    }
`;

export const PartnerTableHeader = styled(PartnerTableCommon)`
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 2px solid #dee2e6;
    height: 50px;
`;

export const PartnerTableRow = styled(PartnerTableCommon)`
    &:hover {
        background: #f8f9fa;
    }
`;

export const PartnerTableCellCommon = styled.div`
    font-size: 14px;
    text-align: center;
    border-right: 1px solid #e9ecef;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 12px;

    &:last-child {
        border-right: none;
    }
`;

export const PartnerTableHeaderCell = styled(PartnerTableCellCommon)`
    font-weight: 600;
    color: #495057;
`;

export const PartnerTableCell = styled(PartnerTableCellCommon)`
    color: #212529;
`;

// 상태 텍스트 스타일
export const StatusText = styled.span`
    font-size: 14px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 20px;
    
    &.status-approved {
        color: #28a745;
        background: rgba(40, 167, 69, 0.1);
    }
    
    &.status-pending {
        color: #6c757d;
        background: rgba(108, 117, 125, 0.1);
    }
`;

// API 상태 관련 스타일
export const ApiStatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

export const ApiStatusText = styled.div`
    font-size: 12px;
    color: #28a745;
    font-weight: 600;
`;

export const ApiActions = styled.div`
    display: flex;
    gap: 4px;
`;

export const ApiManageBtn = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background: #0a3a47;
    }
`;

// 스타일 적용
export default {
    ...responsiveStyles,
    ...responsiveCompanyStyles,
};